module.exports = __webpack_public_path__ + "static/media/envelope_closed.ce755942.png";